var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', {
    staticClass: "mt-3 mb-5 form-integrarion-text"
  }, [_vm._v(" Choose fields to send to " + _vm._s(_vm.integration.title) + " ")]), _c('v-select', {
    attrs: {
      "items": _vm.fields,
      "label": "Select fields",
      "outlined": "",
      "dense": "",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          attrs: {
            "ripple": ""
          },
          on: {
            "mousedown": function ($event) {
              $event.preventDefault();
            },
            "click": _vm.toggle
          }
        }, [_c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "color": _vm.selectedFields.length > 0 ? 'indigo darken-4' : ''
          }
        }, [_vm._v(" " + _vm._s(_vm.icon) + " ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Select All")])], 1)], 1), _c('v-divider', {
          staticClass: "mt-2"
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedFields,
      callback: function ($$v) {
        _vm.selectedFields = $$v;
      },
      expression: "selectedFields"
    }
  }), _c('h3', {
    staticClass: "mt-3 form-integrarion-text"
  }, [_vm._v("Row Data Options")]), _c('v-radio-group', {
    staticClass: "mb-5",
    model: {
      value: _vm.displayAnswer,
      callback: function ($$v) {
        _vm.displayAnswer = $$v;
      },
      expression: "displayAnswer"
    }
  }, [_c('v-radio', {
    staticClass: "mb-3",
    attrs: {
      "label": "Display Answer Values",
      "value": "answer_values"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Display Answer Codes/Index",
      "value": "answer_codes"
    }
  })], 1), _c('div', {
    staticClass: "group-control__wrapper"
  }, [_c('f-switch', {
    staticClass: "mr-2",
    model: {
      value: _vm.sendExisting,
      callback: function ($$v) {
        _vm.sendExisting = $$v;
      },
      expression: "sendExisting"
    }
  }), _vm._v(" Export Existing Data ")], 1), _c('v-row', {
    attrs: {
      "justify": "start"
    }
  }, [_c('v-btn', {
    staticClass: "mt-6 rounded-pill font-weight-medium save-btn",
    attrs: {
      "height": "32",
      "color": "gray_700",
      "outlined": "",
      "text": "",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v(" Save ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }